function createWidgets(/*context, events*/) {}

export default createWidgets
